import React from 'react';

function ErrorPage({ serverAccessState }) {
     if (serverAccessState === -1)
        return (
            <div className="error-container">
                <h3>We're unable to access the database at this time, please try again in a few minutes</h3>
            </div>
        )
     else if (serverAccessState === 0)
        return (
            <div className="loading-container">
                <h3>Please wait while we access your data</h3>
            </div>
        )
}

export default ErrorPage